// Traduzione delle chiavi `form.*` (valori salvati a DB) tramite l'i18n centralizzato.
// La firma resta invariata per i chiamanti esistenti; ora però la traduzione è in
// i18n/locales/{it,en}.ts ed è quindi anche in inglese.

import i18n from "../i18n/index.js";

/** Traduce una chiave `form.*` nell'etichetta della lingua corrente; fallback: ultimo segmento "umanizzato". */
export function formLabel(key?: string): string {
  if (!key) return "";
  // i18next risolve le chiavi annidate con "." (es. form.payment.cash).
  const translated = i18n.t(key, { defaultValue: "" });
  if (translated) return translated;
  const last = key.split(".").pop() ?? key;
  const spaced = last.replace(/[_-]+/g, " ").replace(/([a-z])([A-Z])/g, "$1 $2");
  return spaced.charAt(0).toUpperCase() + spaced.slice(1);
}
